import { Box, Button, Card, Chip, CircularProgress, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { LoadingButton } from "@mui/lab";
import { FormProvider, RHFSelectField, RHFTextField } from "../../common/hook-form";
import ConfirmDialog from "../../common/ConfirmDialog";
import Loader from "../../common/Loader";
import { apiConstants, getGeneric, patch, post } from "../../common/constants";
import { toast } from "react-toastify";
import { escalationArray, formatDate, parseDateAndTime } from "../../helpers/UtilityHelper";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import _ from "lodash";
import DateRangePicker from "../DateRangePicker";
import { subDays } from "date-fns";
import withLayout from "../../hocs/Layout";
import SideDrawer from "../weight/list/SideDrawer";
import CreateTicket from "./CreateTicket";
import PageTitle from "../../common/PageTitle";
import { useNavigate } from "react-router-dom";
import AwbLinkCell from "../../common/AwbLinkCell";
import { awbTextSx } from "../orders/list2/cellStyles";
import MUIModal from "../../common/MUIModal";
import ExportTicketData from "./ExportData";
import { getMerchant } from "../../helpers/ReduxHelpers";
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import GetAppIcon from '@mui/icons-material/GetApp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { useSnackbar } from "notistack";
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, BORDER, SUBTLE, WHITE, LIGHT_BG, PRIMARY_BLUE, SUCCESS, ERROR, withOpacity } from '../../styles/foundation/colors';
import { SHADOW } from '../../styles/foundation/effects';
import { pageContainerSx, helpTextSx, helpTextTypeSx, secondaryBtnSx } from '../../styles/patterns';
import { statusChipSx } from './statusStyles';

const sectionCardSx = {
    bgcolor: WHITE, borderRadius: '12px', boxShadow: SHADOW.card,
    border: `1px solid ${BORDER}`, overflow: 'hidden', mb: 2.5,
};

const iconBtnSx = (color) => ({
    color, bgcolor: withOpacity(color, 0.1), width: 30, height: 30,
    '&:hover': { bgcolor: withOpacity(color, 0.2) },
});

const gradientBtnSx = {
    fontFamily: FONT, textTransform: 'none', fontWeight: WEIGHT.bold, borderRadius: '10px', px: 2.5,
    background: `linear-gradient(135deg, ${PRIMARY_BLUE} 0%, ${NAVY} 100%)`,
    boxShadow: `0 4px 12px ${withOpacity(PRIMARY_BLUE, 0.35)}`,
    '&:hover': { boxShadow: `0 6px 16px ${withOpacity(PRIMARY_BLUE, 0.45)}` },
};
const filterBtnSx = {
    fontFamily: FONT, fontSize: '12px', fontWeight: WEIGHT.bold, textTransform: 'uppercase', letterSpacing: '0.5px',
    px: 2.5, py: 1, borderRadius: '8px', bgcolor: PRIMARY_BLUE, '&:hover': { bgcolor: NAVY },
};
const resetBtnSx = {
    fontFamily: FONT, fontSize: '12px', fontWeight: WEIGHT.bold, textTransform: 'uppercase', letterSpacing: '0.5px',
    px: 2.5, py: 1, borderRadius: '8px', bgcolor: ERROR, color: WHITE, '&:hover': { bgcolor: ERROR, opacity: 0.9 },
};

const EscalationManagement = ({ reload }) => {
    const [show, setShow] = useState(false);
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(30);
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [resData, setresData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [filterChange, setFiltersChange] = useState(0);
    const [currentId, setCurrentId] = useState();
    const [ticketId, setTicketId] = useState()
    // const { userInfo } = useSelector((state) => state.user);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const [statusList, setStatusList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const fetchStatusList = async () => {
            try {
                const response = await getGeneric(`${apiConstants.GET_FRESHDESK_STATUS_LIST}`);
                if (response.data?.status !== "ERROR") {
                    const list = JSON.parse(response?.data?.responseObj);
                    setStatusList(list?.choices);
                } else {
                    enqueueSnackbar("Some error occurred in fetching status list!", { variant: "error" });
                    return;
                }
            } catch (error) {
                enqueueSnackbar("Some error occurred in fetching status list!", { variant: "error" });
                console.error(error);
            }
        }
        fetchStatusList()
    }, [])


    const initialDateRange = [{
        endDate: new Date(),
        startDate: subDays(new Date(), 120),
        key: 'selection'
    }];
    const [dateRange, setDateRange] = useState(initialDateRange)
    const getFormattedDates = (range) => ({
        start_date: formatDate(range[0].startDate, "yyyy-MM-dd"),
        end_date: formatDate(range[0].endDate, "yyyy-MM-dd"),
    });
    const [andFilters, setAndFilters] = useState(getFormattedDates(initialDateRange))

    const columns = [
        {
            field: 'id', headerAlign: "left", headerName: 'Ticket ID', flex: 0.25, minWidth: 100,
            align: 'left', renderCell: (params) => {
                const { row } = params;
                return <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: PRIMARY_BLUE }}>#{row?.id}</Typography>
            },
        },
        {
            field: 'awb', headerAlign: "left", flex: 0.4, headerName: 'AWB(s)',
            align: 'left', renderCell: (params) => {
                const { row } = params;
                return (
                    <>

                        <AwbLinkCell awb={row.custom_fields?.cf_awb_number387695} sx={awbTextSx} fallback="-" />

                    </>
                )

            },
        },
        {
            field: 'createdBy', headerAlign: "left", flex: 0.4, headerName: 'Created By',
            align: 'left', renderCell: (params) => {
                const { row } = params;
                return <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: NAVY }}>{row.custom_fields?.cf_user_name ? row.custom_fields?.cf_user_name : "-"}</Typography>
            },
        },
        {
            field: 'categorySubcategory', headerAlign: "left", flex: 0.8, headerName: 'Category',
            align: 'left', renderCell: (params) => {
                const { row } = params;
                const category = row.custom_fields?.cf_category
                const subcategory = row.custom_fields?.cf_sub_category
                if (!category) return <Typography sx={{ fontSize: SIZE.xs, color: SUBTLE }}>—</Typography>
                return (
                    <Box sx={{ py: 0.5 }}>
                        <Chip size="small" label={category} sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.bold, bgcolor: withOpacity(PRIMARY_BLUE, 0.1), color: PRIMARY_BLUE }} />
                        {subcategory && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4, mt: 0.5, pl: 0.25 }}>
                                <SubdirectoryArrowRightIcon sx={{ fontSize: 12, color: SUBTLE, flexShrink: 0 }} />
                                <Typography sx={{ fontFamily: FONT, fontSize: '0.7rem', color: SUBTLE, lineHeight: 1.2 }}>{subcategory}</Typography>
                            </Box>
                        )}
                    </Box>
                )
            },
        },
        {
            field: 'timeline',
            headerAlign: "left",
            flex: 0.6,
            headerName: 'Timeline',
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                const kSx = { fontFamily: FONT, fontSize: '9px', fontWeight: WEIGHT.bold, color: SUBTLE, textTransform: 'uppercase', letterSpacing: '0.03em' }
                const vSx = (color) => ({ fontFamily: FONT, fontSize: '0.7rem', fontWeight: WEIGHT.semibold, color: color || NAVY, mt: 0.15, whiteSpace: 'nowrap' })
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5, width: '100%' }}>
                        {/* Activity — when it happened */}
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={kSx}>Created</Typography>
                            <Typography sx={vSx()}>{parseDateAndTime(row?.created_at, true)}</Typography>
                            <Typography sx={{ ...kSx, mt: 0.4 }}>Updated</Typography>
                            <Typography sx={vSx()}>{parseDateAndTime(row?.updated_at, true)}</Typography>
                        </Box>
                        <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER }} />
                        {/* Deadlines — what it's due against */}
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={kSx}>FTR Due</Typography>
                            <Typography sx={vSx(ERROR)}>{parseDateAndTime(row?.fr_due_by, true)}</Typography>
                            <Typography sx={{ ...kSx, mt: 0.4 }}>Resolution Due</Typography>
                            <Typography sx={vSx(ERROR)}>{parseDateAndTime(row?.due_by, true)}</Typography>
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: 'status', headerAlign: "left", flex: 0.55, headerName: 'Ticket Status',
            align: 'left', renderCell: (params) => {
                const { row } = params;
                const status = statusList.find((elem) => elem.id === row?.status)
                if (!status) return null
                return (
                    <Tooltip title={status.label_for_customers}>
                        <Chip size="small" label={status.label_for_customers} sx={statusChipSx(status.id)} />
                    </Tooltip>
                )
            },
        },
        {
            field: 'action', headerAlign: "center", flex: 0.3, headerName: 'Actions',
            align: 'center', renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'center' }}>
                        <Tooltip title="View ticket">
                            <IconButton size="small" sx={iconBtnSx(PRIMARY_BLUE)} onClick={() => { view(row?.id, row.custom_fields?.cf_awb_number387695) }}>
                                <VisibilityIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={row.status === 5 ? "Already resolved" : "Close ticket"}>
                            <span>
                                <IconButton size="small" disabled={row.status === 5} sx={iconBtnSx(ERROR)} onClick={() => { toggleDelete(row?.id) }}>
                                    <CancelIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                )
            },
        },
    ]

    const methods = useForm({
        defaultValues: {
            status: '',
            category: '',
            subcategory: '',
            awb: ''
        }
    });
    const { handleSubmit, reset } = methods;

    // const selectedCategory = watch("category");
    const data = escalationArray.filter((val) => val.categoryTitle);
    const categoryOptions = _.orderBy(data, "name").map((val) => ({
        value: val.categoryTitle,
        label: val.categoryTitle,
    }));

    const subCategoriesArray = escalationArray.flatMap(category =>
        category.subCategories.map(subCategory => ({
            name: subCategory.name,
            subCatTitle: subCategory.subCatTitle
        }))
    );

    // const subcategoryOptions =
    //     selectedCategory &&
    //     data.find((val) => val.categoryTitle === selectedCategory)?.subCategories.map((subCat) => ({
    //         value: subCat.subCatTitle,
    //         label: subCat.subCatTitle,
    //     }));
    const subcategoryOptions =
        subCategoriesArray?.map((subCat) => ({
            value: subCat.subCatTitle,
            label: subCat.subCatTitle,
        }));



    const onSubmit = (filters) => {
        let payload = {
            start_date: formatDate(dateRange[0].startDate, "yyyy-MM-dd"),
            end_date: formatDate(dateRange[0].endDate, "yyyy-MM-dd"),
        }
        if (filters.status) {
            payload.status_list = [filters.status]
        }
        if (filters.category) {
            payload.category_list = [filters.category]
        }
        if (filters.subcategory) {
            payload.subcategory_list = [filters.subcategory]
        }
        if (filters.awb) {
            payload.awbnumber_list = [filters.awb]
        }
        setAndFilters(payload)
    }

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                const response = await post(`${apiConstants.BASE_LOCAL}${apiConstants.FILTER_FRESHDESK}`, {
                    ...andFilters,
                    page: page + 1,
                    merchantOid: merchantId
                });
                const parsedRes = JSON.parse(response.data?.responseObj);
                setresData(parsedRes);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error(error);
                toast("Some error occurred!", { type: "error" });
            }
        };

        fetchData();
    }, [andFilters, reload, page, filterChange, merchantId]);

    // Real KPI numbers, scoped to the same date/filter range as the grid — not the current
    // page's slice. Open/Resolved come from dedicated count queries; Avg Resolution and SLA
    // Compliance are computed from the resolved tickets in that same range (created_at -> updated_at
    // as the resolution time, compared against due_by for SLA).
    const [kpiStats, setKpiStats] = useState({ open: null, resolved: null, avgResolutionHrs: null, slaPct: null });
    const [kpiLoading, setKpiLoading] = useState(true);

    useEffect(() => {
        if (!statusList.length) return;
        const nonResolvedIds = statusList.filter((s) => s.id !== 4 && s.id !== 5).map((s) => s.id);
        const fetchKpiStats = async () => {
            setKpiLoading(true);
            try {
                const [openRes, resolvedRes] = await Promise.all([
                    post(`${apiConstants.BASE_LOCAL}${apiConstants.FILTER_FRESHDESK}`, {
                        ...andFilters, status_list: nonResolvedIds, page: 1, merchantOid: merchantId,
                    }),
                    post(`${apiConstants.BASE_LOCAL}${apiConstants.FILTER_FRESHDESK}`, {
                        ...andFilters, status_list: [4, 5], page: 1, merchantOid: merchantId,
                    }),
                ]);
                const openParsed = JSON.parse(openRes.data?.responseObj);
                const resolvedParsed = JSON.parse(resolvedRes.data?.responseObj);
                const resolvedTickets = resolvedParsed?.results || [];

                const resolutionHours = resolvedTickets
                    .map((t) => (new Date(t.updated_at) - new Date(t.created_at)) / 3600000)
                    .filter((h) => Number.isFinite(h) && h >= 0);
                const avgResolutionHrs = resolutionHours.length
                    ? resolutionHours.reduce((a, b) => a + b, 0) / resolutionHours.length
                    : null;

                const withDueDate = resolvedTickets.filter((t) => t.due_by);
                const withinSla = withDueDate.filter((t) => new Date(t.updated_at) <= new Date(t.due_by)).length;
                const slaPct = withDueDate.length ? Math.round((withinSla / withDueDate.length) * 100) : null;

                setKpiStats({
                    open: openParsed?.total ?? 0,
                    resolved: resolvedParsed?.total ?? 0,
                    avgResolutionHrs, slaPct,
                });
            } catch (error) {
                console.error(error);
            } finally {
                setKpiLoading(false);
            }
        };
        fetchKpiStats();
    }, [andFilters, reload, filterChange, merchantId, statusList]);

    const handleReset = () => {
        reset({
            status: '',
            category: '',
            subcategory: ''
        });
        setDateRange(initialDateRange)
        setAndFilters(getFormattedDates(initialDateRange));
        // setFiltersChange(filterChange + 1);
    }

    const closeticket = (id) => {
        patch(`${apiConstants.BASE_LOCAL}${apiConstants.CLOSE_FRESHDESK}/${id}`).then((res) => {
            setFiltersChange(filterChange + 1);
        }).catch((err) => {
            console.log(err);
            toast("Some error occurred!", { type: "error" });
        })
    }

    const toggleDelete = (id) => {
        setCurrentId(id);
        setDeleteConfirm(true);
    };

    const navigate = useNavigate()
    const view = (id, awb) => {
        navigate(`/escalation_management/view?awb=${awb}&ticketId=${id}`)
    }
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false)
    }
    const handleOpen = () => {
        setOpen(true)
        setSidebarOpen(false)
    }
    const totalTickets = resData?.total || 0;

    const kpis = [
        { label: 'Total Tickets', value: totalTickets, loading: isLoading, color: PRIMARY_BLUE, icon: <ConfirmationNumberOutlinedIcon />, info: 'All tickets raised in the selected date range.' },
        { label: 'Open Tickets', value: kpiStats.open, loading: kpiLoading, color: PRIMARY_BLUE, icon: <PendingActionsOutlinedIcon />, info: 'Tickets that are not yet Closed or Resolved.' },
        { label: 'Resolved', value: kpiStats.resolved, loading: kpiLoading, color: SUCCESS, icon: <CheckCircleOutlineIcon />, info: 'Tickets marked Closed or Resolved.' },
        { label: 'Avg Resolution', value: kpiStats.avgResolutionHrs != null ? `${kpiStats.avgResolutionHrs.toFixed(1)} hrs` : '—', loading: kpiLoading, color: NAVY, icon: <AccessTimeOutlinedIcon />, info: 'Average time from creation to resolution, across resolved tickets in this date range.' },
        { label: 'SLA Compliance', value: kpiStats.slaPct != null ? `${kpiStats.slaPct}%` : '—', loading: kpiLoading, color: SUCCESS, icon: <VerifiedOutlinedIcon />, info: 'Share of resolved tickets closed on or before their resolution due date.' },
    ];

    return (
        <Box sx={pageContainerSx}>
            <PageTitle>Help & Support</PageTitle>

            {/* Header */}
            <Box sx={{ mb: 2.5, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{
                    width: 48, height: 48, borderRadius: '12px', flexShrink: 0,
                    background: `linear-gradient(135deg, ${PRIMARY_BLUE} 0%, ${NAVY} 100%)`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: `0 4px 14px ${withOpacity(PRIMARY_BLUE, 0.35)}`,
                }}>
                    <SupportAgentOutlinedIcon sx={{ color: WHITE, fontSize: 26 }} />
                </Box>
                <Box>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.lg, fontWeight: WEIGHT.extra, color: NAVY }}>Help & Support</Typography>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE, mt: 0.2 }}>Raise, track, and resolve support tickets for your shipments</Typography>
                </Box>
            </Box>

            {isLoading && <Loader />}

            {/* KPI strip */}
            <Box sx={{
                display: 'grid', gridTemplateColumns: { xs: 'repeat(2,1fr)', sm: 'repeat(3,1fr)', md: 'repeat(5,1fr)' },
                bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '12px', overflow: 'hidden',
                boxShadow: SHADOW.card, mb: 2.5,
            }}>
                {kpis.map((s) => (
                    <Box key={s.label} sx={{ p: 1.75, borderRight: `1px solid ${BORDER}`, borderBottom: `1px solid ${BORDER}` }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
                            <Box sx={{ color: s.color, display: 'flex', '& svg': { fontSize: 15 } }}>{s.icon}</Box>
                            <Typography sx={{ fontFamily: FONT, fontSize: '9.5px', fontWeight: WEIGHT.extra, letterSpacing: '0.05em', textTransform: 'uppercase', color: SUBTLE }}>{s.label}</Typography>
                            <Tooltip title={s.info} arrow placement="top">
                                <InfoOutlinedIcon sx={{ fontSize: 11, color: SUBTLE, opacity: 0.7, cursor: 'help' }} />
                            </Tooltip>
                        </Box>
                        {s.loading ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.9, height: '22px' }}>
                                <CircularProgress size={14} thickness={5.5} sx={{ color: s.color }} />
                                <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontStyle: 'italic' }}>Calculating…</Typography>
                            </Box>
                        ) : (
                            <Typography sx={{ fontFamily: FONT, fontSize: '22px', fontWeight: WEIGHT.extra, color: s.color, lineHeight: 1, mt: 0.75, fontVariantNumeric: 'tabular-nums' }}>
                                {s.value}
                            </Typography>
                        )}
                    </Box>
                ))}
            </Box>

            <Box sx={helpTextSx}>
                <InfoOutlinedIcon sx={{fontSize: 16, color: PRIMARY_BLUE, mt: 0.2}} />
                <Typography sx={helpTextTypeSx}>
                    <strong>Ticket types:</strong> Tickets raised by your team and tickets raised by the ProShip support team (when visible to merchant) are both shown here.
                    Resolution time and SLA compliance are tracked automatically. History is retained for up to 12 months.
                </Typography>
            </Box>

            {/* Filter + actions */}
            <Card sx={{ ...sectionCardSx, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <Box sx={{ p: 2.25 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
                        <Button variant="contained" onClick={() => setSidebarOpen(true)} startIcon={<AddCircleOutlineIcon />} sx={gradientBtnSx}>
                            Create Ticket
                        </Button>
                        <Button variant="outlined" size="small" sx={secondaryBtnSx} onClick={() => setShow(true)} startIcon={<GetAppIcon />}>
                            Export
                        </Button>
                    </Box>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-end' }}>
                            <Box sx={{ minWidth: 220 }}>
                                <Typography sx={{ fontFamily: FONT, fontSize: '10px', fontWeight: WEIGHT.bold, color: SUBTLE, textTransform: 'uppercase', letterSpacing: '0.04em', mb: 0.5 }}>Date Range</Typography>
                                <DateRangePicker
                                    defaultRange={dateRange}
                                    maxDate={new Date()}
                                    showTextBox={true}
                                    onChange={(range) => setDateRange(range)}
                                />
                            </Box>
                            <Box sx={{ minWidth: 130 }}>
                                <RHFTextField label="AWB" name="awb" color="primary" size="small" fullWidth />
                            </Box>
                            <Box sx={{ minWidth: 150 }}>
                                <RHFSelectField
                                    label="Status" name="status" size="small" fullWidth
                                    options={statusList.map((val) => ({ value: val.id, label: val.label_for_customers }))}
                                />
                            </Box>
                            <Box sx={{ minWidth: 170 }}>
                                <RHFSelectField label="Category" name="category" size="small" fullWidth options={_.orderBy(categoryOptions, 'label', 'asc')} />
                            </Box>
                            <Box sx={{ minWidth: 170 }}>
                                <RHFSelectField label="Subcategory" name="subcategory" size="small" fullWidth options={subcategoryOptions} />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <LoadingButton type="submit" variant="contained" sx={filterBtnSx}>Filter</LoadingButton>
                                <Button variant="contained" sx={resetBtnSx} onClick={() => { handleReset() }}>Reset</Button>
                            </Box>
                        </Box>
                    </FormProvider>
                </Box>
            </Card>

            {/* Ticket history */}
            <Box sx={sectionCardSx}>
                <Box sx={{px: 2.5, py: 2, borderBottom: `1px solid ${BORDER}`}}>
                    <Typography sx={{fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.bold, color: NAVY}}>Ticket History</Typography>
                    <Typography sx={{fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, mt: 0.3}}>Showing tickets from the last 12 months — filter by date, status, category, or AWB</Typography>
                </Box>
                <Box sx={{
                    p: 1,
                    '& .MuiDataGrid-root': { border: 'none' },
                    '& .MuiDataGrid-columnHeaders': { backgroundColor: LIGHT_BG, borderBottom: `1px solid ${BORDER}` },
                    '& .MuiDataGrid-columnHeaderTitle': { fontFamily: FONT, fontWeight: WEIGHT.extra, fontSize: '0.7rem', color: SUBTLE, textTransform: 'uppercase', letterSpacing: '0.03em' },
                    '& .MuiDataGrid-row:hover': { backgroundColor: LIGHT_BG },
                    '& .MuiDataGrid-cell': { borderBottom: `1px solid ${BORDER}`, fontFamily: FONT, fontSize: '0.8rem' },
                }}>
                    <ProzoDataGrid
                        columns={columns}
                        rows={resData?.results?.length > 0 ? resData?.results : []}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={true}
                        hideFooterPagination={false}
                        paginationMode={"server"}
                        rowCount={resData?.total || 0}
                        getRowId={(row) => row.id}
                    />
                </Box>
            </Box>
            <ExportTicketData
                show={show}
                setShow={setShow}
                merchantOid={merchantId}
                handleClose={() => setShow(false)}
                statusList={statusList}
            />
            <ConfirmDialog
                title=''
                open={deleteConfirm}
                setOpen={setDeleteConfirm}
                onConfirm={() => closeticket(currentId)}
            >
                Are you sure you want to close this ticket?
            </ConfirmDialog>
            <MUIModal
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', px: 1 }}>
                    <Box sx={{
                        width: 56, height: 56, borderRadius: '50%', bgcolor: withOpacity(SUCCESS, 0.12),
                        display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1.5, color: SUCCESS, '& svg': { fontSize: 30 },
                    }}>
                        <CheckCircleOutlinedIcon />
                    </Box>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.lg, fontWeight: WEIGHT.bold, color: NAVY }}>Ticket Created Successfully</Typography>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: ERROR, mt: 1 }}>
                        Updates may take up to a minute to appear on your screen. Kindly avoid making duplicate requests.
                    </Typography>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.semibold, color: NAVY, mt: 1.5 }}>Ticket ID : {ticketId}</Typography>
                </Box>
            </MUIModal>
            <SideDrawer
                title='Create Ticket'
                subtitle='Provide details to raise a support case'
                icon={<ConfirmationNumberOutlinedIcon sx={{ fontSize: 22 }} />}
                open={sidebarOpen ? true : false} setOpen={() => setSidebarOpen(false)}
                children={<CreateTicket
                    setFiltersChange={setFiltersChange}
                    handleOpen={handleOpen}
                    setTicketId={setTicketId}
                    statusList={statusList}
                />}>
            </SideDrawer>
        </Box>
    )
}

export default withLayout(EscalationManagement)
